import * as React from "react";
import styled, { css } from "styled-components";
const Steps = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: flex-bottom;
    justify-content: space-between;
    margin-bottom: ${theme.spacings.md};
  `
);
const StepNumber = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  border: 2px solid;
  border-color: ${({ theme, $active, $error, $disabled }) => {
  if ($disabled) return theme.colors.input.placeholder;
  if ($error) return theme.colors.variant.danger;
  if ($active) return theme.colors.global.link;
  return theme.colors.gray[40];
}};
  color: ${({ theme, $active, $error, $disabled }) => {
  if ($disabled) return theme.colors.input.placeholder;
  if ($error) return theme.colors.variant.danger;
  if ($active) return theme.colors.global.link;
  return theme.colors.gray[40];
}};
`;
const StepTextColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;

  color: ${({ theme, $active, $error, $disabled }) => {
  if ($disabled) return theme.colors.input.placeholder;
  if ($error) return theme.colors.variant.danger;
  if ($active) return theme.colors.global.link;
  return theme.colors.gray[40];
}};
`;
const StepSeparator = styled.hr`
  border: 1px solid ${({ theme }) => theme.colors.input.border};
  width: 100%;
  flex-shrink: 1;
  flex-grow: 0;
  align-self: center;
  margin: 0 16px;
`;
const Step = styled.div`
  display: flex;
  flex-grow: 1;
  flex-shrink: 0;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  gap: 8px;

  &:hover,
  &:hover > div {
    ${({ theme, $disabled }) => $disabled ? css`
            cursor: not-allowed;
          ` : css`
            color: ${theme.colors.global.linkHover};
            border-color: ${theme.colors.global.linkHover};
          `}
  }
`;
function Stepper({ steps, activeStep, gap = "8px", setActiveStep }) {
  return /* @__PURE__ */ React.createElement(Steps, { $gap: gap }, steps.map((step, index) => /* @__PURE__ */ React.createElement(React.Fragment, { key: step.id }, index > 0 && /* @__PURE__ */ React.createElement(StepSeparator, null), /* @__PURE__ */ React.createElement(Step, { key: step.id, $disabled: step.disabled, onClick: () => step.disabled || setActiveStep(index) }, /* @__PURE__ */ React.createElement(StepNumber, { $active: index === activeStep, $error: !step.valid, $disabled: step.disabled }, index + 1), /* @__PURE__ */ React.createElement(StepTextColumn, { $active: index === activeStep, $error: !step.valid, $disabled: step.disabled }, /* @__PURE__ */ React.createElement("span", null, step.title))))));
}
export default Stepper;
